export enum Identifiers {
  Module1 = 0,
  Module2 = 1,
  Module3 = 2,
  AllModules = '*'
}

export enum AssetIconKeys {
  Module1 = 'Module 1',
  Module2 = 'Module 2',
  Module3 = 'Module 3'
}
// these are the asset names
export enum AssetIconNames {
  Module1 = 'AA_Module_1',
  Module2 = 'AA_Module_2',
  Module3 = 'AA_Module_3'
}
